import product1 from "../assets/products/product-1.png";
import product2 from "../assets/products/product-2.png";
import product3 from "../assets/products/product-3.png";
import product4 from "../assets/products/product-4.png";
import product5 from "../assets/products/product-5.png";
import product6 from "../assets/products/product-6.png";
import product7 from "../assets/products/product-7.png";

export const products = [
    {
        title: "Sementes de melancia",
        description: "Cultivadas com cuidado e colhidas no auge da maturidade, essas sementes são garantia de plantas saudáveis e produtivas. Seu potencial de crescimento é notável, e as melancias Crimson são conhecidas por atingirem tamanhos generosos, sendo ideais para compartilhar com a família e os amigos em um dia quente de verão.",
        image: product1
    },
    {
        title: "Sementes de soja",
        description: "A soja é uma leguminosa de origem asiática e tem sido amplamente cultivada devido aos seus benefícios nutricionais e versatilidade culinária. As sementes de soja são ricas em proteínas, fibras, ácidos graxos essenciais e uma variedade de vitaminas e minerais, tornando-as um ótimo complemento para uma dieta saudável e equilibrada.",
        image: product2
    },
    {
        title: "Sementes de trigo",
        description: "Sementes de trigo são provenientes de variedades selecionadas, desenvolvidas por meio de pesquisas e melhoramento genético avançado. Elas são adaptadas para se adequar a diferentes condições de cultivo, permitindo que você obtenha o máximo potencial de sua lavoura.",
        image: product3
    },
    {
        title: "Cortador de grama",
        description: "Este cortador de grama foi projetado para oferecer desempenho excepcional e facilidade de uso. Equipado com um motor potente, ele garante um corte preciso e uniforme, independentemente do tamanho do seu gramado. A lâmina afiada e resistente corta a grama de forma limpa, proporcionando resultados profissionais.",
        image: product4
    },
    {
        title: "Trator",
        description: "Com um design robusto e durável, o Trator da Terragro é construído para enfrentar os desafios do manejo agrícola de pequena e larga escala. Equipado com tecnologia avançada e recursos inovadores, ele oferece potência, versatilidade e facilidade de operação.",
        image: product5
    },
    {
        title: "Sementes de milho",
        description: "Nossas sementes de milho são provenientes de variedades de alto desempenho, desenvolvidas através de pesquisas e melhoramento genético avançado. Elas são adaptadas para se adaptar a diferentes condições de cultivo, permitindo que você obtenha o máximo potencial de sua safra de milho.",
        image: product6
    },
    {
        title: "Sementes de tomate",
        description: "Nossas sementes de tomate são provenientes de variedades premium, desenvolvidas por meio de técnicas avançadas de melhoramento genético. Elas são escolhidas para se adaptarem a diferentes climas e condições de cultivo, permitindo que você desfrute de uma colheita abundante e saudável.",
        image: product7
    }
];